function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m360.089844 336.164062c-92.785156 0-168-75.214843-168-168 .945312-71.269531 45.359375-134.714843 112-160-23.476563-6.1875-47.738282-8.882812-72-8-128.132813 0-232.0000002 103.871094-232.0000002 232 0 128.128907 103.8671872 232 232.0000002 232 97.191406 1.050782 184.175781-60.15625 216-152-26.28125 16.601563-56.929688 24.960938-88 24zm0 0",
  fill: "#fce666"
});

var SvgClearNight = function SvgClearNight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "464pt",
    viewBox: "-8 0 464 464.177",
    width: "464pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClearNight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clear-night.632833f9.svg";
export { ForwardRef as ReactComponent };